import { render, staticRenderFns } from "./BandeiraList.vue?vue&type=template&id=6f488e4d&scoped=true"
import script from "./BandeiraList.vue?vue&type=script&lang=js"
export * from "./BandeiraList.vue?vue&type=script&lang=js"
import style0 from "./BandeiraList.vue?vue&type=style&index=0&id=6f488e4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f488e4d",
  null
  
)

export default component.exports